/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.ParticipantsGrid = require('./participants/participants_grid');

window.Participants = {
  _selectSingularRole() {
    const roles = $('input[id^="company_invitation"]');
    if (roles.length === 1) {
      return roles.prop('checked', true).closest('tr').addClass('selected');
    }
  },

  _toggleDisableSubmitButton(event) {
    const $submitButton = $('input[type="submit"]');

    if ($(event.currentTarget).is(':checked')) {
      return $submitButton.removeClass('disabled');
    } else {
      return $submitButton.addClass('disabled');
    }
  },

  initializeOptOutModal() {
    $(document).on('change', 'input[name="confirm"]', _.bind(this._toggleDisableSubmitButton, this));
    $(document).on('change', 'input[id^="company_invitation"]', function() {
      return $(this).closest('tr').toggleClass('selected');
    });

    return this._selectSingularRole();
  },

  initializeModalConfirmation() {
    $(document).on('click', '#confirm', () => $('#tender_submit').toggleClass('disabled'));

    return $(document).on('change', '#bid_request input[type=checkbox].confirm', () => $('#bid_request input[type=submit]').toggleClass('disabled'));
  }
};
